import React, { useEffect } from 'react'
import { Box, Typography } from '@mui/material'
import { StepProps } from '../../../components/_WMS/Stepper'
import { AsnLocateResult, AsnLocateState, eStepAsnLocate } from '../types'
import { ExpandableCardList } from '../../../components/_WMS/ExpandableCardList/ExpandableCardList'

interface ResultsStepProps extends StepProps<AsnLocateState> {}

const asnFields = [
  {
    label: 'Proveedor',
    getValue: (item: AsnLocateResult) => item.supplierName
  },
  {
    label: 'Origen',
    getValue: (item: AsnLocateResult) => item.supplierOriginName
  },
  {
    label: 'Unidades Totales',
    getValue: (item: AsnLocateResult) => item.unitsQty
  },
  { label: 'Marca', getValue: (item: AsnLocateResult) => item.brandName }
]

export const ResultsStep: React.FC<ResultsStepProps> = ({
  sharedState,
  setSharedState,
  goToStep
}) => {
  useEffect(() => {
    setSharedState((prev) => ({
      ...prev,
      stepTitle: 'Selecciona la ASN que necesita gestionar'
    }))
    return () => {
      setSharedState((prev) => ({ ...prev, stepTitle: undefined }))
    }
  }, [])

  const handleSelect = (item: AsnLocateResult) => {
    setSharedState((prev) => ({ ...prev, selectedResult: item }))
    goToStep(
      item.withLpn ? eStepAsnLocate.LpnStep : eStepAsnLocate.LocateStepV2
    )
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        padding: 2,
        gap: 1,
        height: '100%',
        overflow: 'hidden'
      }}
    >
      <Typography
        variant='overline'
        sx={{
          fontWeight: 'bold',
          color: '#555',
          letterSpacing: 2,
          flexShrink: 0
        }}
      >
        Resultados
      </Typography>
      <Box sx={{ flex: 1, overflowY: 'auto' }}>
        <ExpandableCardList
          items={sharedState.results}
          getKey={(item) => item.asnId}
          renderHeader={(item) => (
            <Typography variant='body2' fontWeight='bold'>
              {item.asnNumber}
            </Typography>
          )}
          fields={asnFields}
          onSelect={handleSelect}
        />
      </Box>
    </Box>
  )
}
